import styled from '@emotion/styled';
import { css } from '@emotion/react';
import pulse from '../assets/animation/pulse';

const PulsingEffect = css`
	animation: ${pulse} 1.5s infinite 3s cubic-bezier(0.55, 0.5, 0, 1);
	box-shadow: 0 0 0 0 #333;
`;

const PulsingButton = styled.a`
	${PulsingEffect};
	font-family: Project;
	position: relative;
	color: #333;
	text-decoration: none;
	display: inline-block;
	text-transform: uppercase;
	letter-spacing: 1px;
	border: 1.5px hidden #333;
	border-radius: 100%;
	padding: 30%;
	box-shadow: 0 24x 10px 0 #333;
	transition: 0.4s all ease-in-out;
	&:hover {
		cursor: pointer;
		border: 3px solid #333;
	}
`;

export { PulsingButton };
